import React, { useState } from 'react';
import InputLabel from '../InputLabel';
import InputError from '../InputError';
import InputSuccess from '../InputSuccess';

import './Input.css';

export default function Input({ onChange, label, info, containerStyle, className, labelClassName, error, success, isnumeric, allowspaces, isphone, disabled, placeholder, showToggle, ...rest })
{
    const [visible, setVisible] = useState(false);

    const handleInput = (e)=>{
        if( isnumeric )
            e.target.value = e.target.value.replace(/[^0-9]/g, '');

        if( allowspaces === false )
            e.target.value = e.target.value.replace(/ /g, '');

        if( isphone )
            e.target.value = e.target.value.replace(/\+/g, '');

        return onChange(e);
    }

    const inputType = showToggle && rest.type === 'password'
        ? (visible ? 'text' : 'password')
        : rest.type;

    return (
        <div className="input-container" style={containerStyle}>
            { label ? <InputLabel label={label} info={info} className={labelClassName}/> : null }
            <div className="input-content">
                <input
                    {...rest}
                    type={inputType}
                    disabled={disabled}
                    placeholder={placeholder}
                    title={placeholder || label || info || ''}
                    className={'input ' + (error ? ' error ' : '') + (className || '')}
                    onChange={handleInput}
                />
                {showToggle && (
                    <button
                        type="button"
                        className="input-toggle"
                        onClick={() => setVisible(v => !v)}
                        tabIndex={-1}
                    >
                        <span className="material-symbols-outlined">
                            {visible ? 'visibility_off' : 'visibility'}
                        </span>
                    </button>
                )}
            </div>

            { error ? <InputError error={error}/> : null }
            { success ? <InputSuccess message={success}/> : null }
        </div>
    )
}